// import React from 'react';
// import { Spin } from 'antd'; 

// const LoadingOverlay = ({ isLoading, children }) => {
//   return (
//     <div style={{ position: 'relative' }}>
//       {isLoading && (
//         <div
//           style={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             backgroundColor: 'rgba(0, 0, 0, 0)', 
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 1000, 
//           }}
//         >
//           <Spin size="large" />
//         </div>
//       )}
//       {children}
//     </div>
//   );
// };

// export default LoadingOverlay;

import React from 'react';

const LoadingOverlay = ({ isLoading, children }) => {
  return (
    <div style={{ position: 'relative' }}>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)', 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000, 
          }}
        >
          <div className="spinner" style={spinnerStyle}></div>
        </div>
      )}
      {children}
    </div>
  );
};

const spinnerStyle = {
  width: '80px',
  height: '80px',
  border: '8px solid #f3f3f3',
  borderTop: '8px solid #3498db',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};


export default LoadingOverlay;
